// extracted by mini-css-extract-plugin
module.exports = {"main_container":"MainContent_main_container__3YK0u","virtualized_wrapper":"MainContent_virtualized_wrapper__3-Dnc","action_wrapper":"MainContent_action_wrapper__2LUUt"};